<template>
    <el-dialog title="提现转账信息" :visible.sync="formVisible" :close-on-click-modal="true">
        <el-row class="text item infoItem">
            <el-col :span="6">方式：</el-col>
            <el-col :span="18">
                <el-tag type="success" v-if="infos.fs == 'geren'">个人</el-tag>
                <el-tag type="warning" v-else-if="infos.fs == 'qiye'">企业</el-tag>
                <el-tag v-else>支付宝</el-tag>
            </el-col>
        </el-row>
        <div v-if="infos.fs == 'geren'">
            <el-row class="text item infoItem">
                <el-col :span="6">姓名：</el-col>
                <el-col :span="18">{{ infos.idname }}</el-col>
            </el-row>
            <el-row class="text item infoItem">
                <el-col :span="6">身份号：</el-col>
                <el-col :span="18">{{ infos.idcard }}</el-col>
            </el-row>
            <el-row class="text item infoItem">
                <el-col :span="6">银行卡：</el-col>
                <el-col :span="18">{{ infos.banknum }}</el-col>
            </el-row>
            <el-row class="text item infoItem">
                <el-col :span="6">开户行：</el-col>
                <el-col :span="18">{{ infos.bankaddr }}</el-col>
            </el-row>
        </div>
        <div v-else-if="infos.fs == 'qiye'">
            <el-row class="text item infoItem">
                <el-col :span="6">企业名称：</el-col>
                <el-col :span="18">{{ infos.qyname }}</el-col>
            </el-row>
            <el-row class="text item infoItem">
                <el-col :span="6">统一信用码：</el-col>
                <el-col :span="18">{{ infos.qynum }}</el-col>
            </el-row>
            <el-row class="text item infoItem">
                <el-col :span="6">银行帐户：</el-col>
                <el-col :span="18">{{ infos.banknum }}</el-col>
            </el-row>
            <el-row class="text item infoItem">
                <el-col :span="6">开户行：</el-col>
                <el-col :span="18">{{ infos.bankaddr }}</el-col>
            </el-row>
        </div>
        <div v-else>
            <el-row class="text item infoItem">
                <el-col :span="6">身份号：</el-col>
                <el-col :span="18">{{ infos.aliid }}</el-col>
            </el-row>
            <el-row class="text item infoItem">
                <el-col :span="6">姓名：</el-col>
                <el-col :span="18">{{ infos.aliname }}</el-col>
            </el-row>
        </div>
    </el-dialog>
</template>


<script>
export default {
    data() {
        return {
            formVisible: false,

            infos: '',
        }
    },
    mounted() {
    },
    methods: {
        show(infos) {
            if (!infos || infos == '') {
                return;
            }
            const info = JSON.parse(infos)
            this.formVisible = true;
            this.infos = info;
        },
    }
}
</script>

<style scoped>
.infoItem {
    padding: 10px;
}
</style>


// WEBPACK FOOTER //
// txTaxTips.vue?28824a2b